import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'sera-label-value',
    templateUrl: './sera-label-value.component.html',
    styleUrls: ['./sera-label-value.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraLabelValueComponent {
    @Input() label?: string | null;
    @Input() value?: string | number | null;
    @Input() valueDescription?: string | null;
    @Input() containerClass?: string | null;
    @Input() inputText: boolean = false;
}
